import styled, { css } from 'styled-components';

const shouldForwardProp = prop => !['backgroundColor', 'size', 'variant'].includes(prop);

const getColorStyles = color => {
  switch (color) {
    case 'primary':
      return css`
        background: var(--Primary-100);
        color: var(--Primary-800);
      `;
    case 'secondary':
      return css`
        background: var(--Secondary-800);
        color: var(--GrayScale-100);
      `;
    case 'error':
      return css`
        background: var(--Error-100);
        color: var(--Error-500);
      `;
    case 'success':
      return css`
        background: var(--Success-100);
        color: var(--Success-600);
      `;
    case 'warning':
      return css`
        background: var(--Warning-100);
        color: var(--GrayScale-700);
      `;
    case 'default':
      return css`
        background: var(--GrayScale-100);
        color: var(--GrayScale-700);
      `;
    default:
      return css`
        background: var(--GrayScale-200);
      `;
  }
};

const getSizeStyles = size => {
  switch (size) {
    case 'small':
      return css`
        ;
      `;
    case 'medium':
      return css``;

    case 'large':
      return css``;
    default:
      return css`
        font-size: 12px;
        font-style: normal;
        font-weight: 500;
        line-height: 16px;
      `;
  }
};

const getVariantStyles = variant => {
  switch (variant) {
    case 'eDocuments':
      return css`
        font-family: Pretendard;
        padding: 8px 12px;
        font-size: 14px;
        font-style: normal;
        font-weight: 500;
        line-height: 20px;
      `;
  }
};

const ChipsStyled = styled.div.withConfig({ shouldForwardProp })`
  display: flex;
  padding: 2px 8px;
  justify-content: center;
  align-items: center;
  gap: 4px;
  border-radius: 100px;
  width: fit-content;

  ${props => {
    return css`
      ${getColorStyles(props.color)}
      ${getSizeStyles(props.size)}
      ${getVariantStyles(props.variant)}
    `;
  }}
`;

export default ChipsStyled;
